export default __webpack_public_path__ + "static/media/i (28).093d0970.jpg";